import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useColorModeValue,
} from "@chakra-ui/react";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const ExamDetails = () => {
  const { classId } = useParams();
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const schoolId = sessionStorage.getItem("school_id");


    const [academicId, setAcademicId] = useState(
      sessionStorage.getItem("Academic")
    );
  
    useEffect(() => {
      const handleStorageChange = () => {
        setAcademicId(sessionStorage.getItem("Academic"));
      };
  
      window.addEventListener("storage", handleStorageChange);
  
      return () => {
        window.removeEventListener("storage", handleStorageChange);
      };
    }, []);

  useEffect(() => {
    const fetchExams = async () => {
      console.log("Class ID from URL:", classId);

      try {
        const response = await fetch(
          `${BASE_URL}/admin/exam/list_class_exam.php?class_id=${classId}&&school_id=${schoolId}`
        );
        console.log("API.... Response:", response);

        if (response.ok) {
          const data = await response.json();
          console.log("Fetched ...Exam Data:", data);

          if (data.success) {
              // Filter exams based on academic year
          const filteredExams = data.data.filter(
            (exam) => exam.academic_year_id === academicId
          );

          setExams(filteredExams);
          } else {
            setError(data.message);
          }
        } else {
          setError(`Error: ${response.status} - ${response.statusText}`);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to fetch exam data");
      } finally {
        setLoading(false);
      }
    };

    if (classId) {
      fetchExams();
    } else {
      setError("Class ID is missing in the URL");
      setLoading(false);
    }
  }, [academicId,classId]);

  // Group exams by category (e.g., "First Term", "Second Term")
  const examsByCategory = exams.reduce((acc, exam) => {
    const category = exam.category || "Uncategorized";
    if (!acc[category]) acc[category] = [];
    acc[category].push(exam);
    return acc;
  }, {});

  const bgColor = useColorModeValue("gray.100", "gray.700");
  const headingColor = useColorModeValue("blue.600", "blue.300");

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      <Accordion allowMultiple>
        {Object.entries(examsByCategory).map(([category, exams]) => (
          <AccordionItem
            key={category}
            // border="1px solid"
            // borderColor="gray.300"
            borderRadius="md"
            mb={4}
            boxShadow="0px 4px 6px rgba(0, 0, 0, 0.1)"
            _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
            color="white"
          >
            <h2>
              <AccordionButton
                _expanded={{
                  bg: "blue.100",
                  color: "white",
                }}
                bgGradient="linear(to-r, teal.400, blue.400)"
                _hover={{
                  bgGradient: "linear(to-r, teal.300, blue.300)",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                }}
                // _expanded={{
                //   bgGradient: "linear(to-r, teal.500, blue.500)",
                //   color: "white",
                //   boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                // }}
                borderRadius="md"
                color="white"
                py={4}
              >
                <Box flex="1" textAlign="left" fontWeight="bold" color="white">
                  {category}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel
              pb={4}
              bg={bgColor}
              borderRadius="md"
              overflowX="auto"
            >
              <Table
                sx={{
                  "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
                }}
              >
                <Thead bg="blue.50">
                  <Tr>
                    <Th>Serial No.</Th>
                    <Th>Subject</Th>
                    <Th>Staff</Th>
                    <Th>Max Mark</Th>
                    <Th>Pass Mark</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {exams.map((exam, index) => (
                    <Tr key={exam.id}>
                      <Td>{index + 1}</Td> {/* Serial number based on index */}
                      <Td>{exam.subject}</Td>
                      <Td>{exam.name}</Td>
                      <Td>{exam.max_marks}</Td>
                      <Td>{exam.pass_marks}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default ExamDetails;
